<template>
  <fragment>
    <td class="clickable" v-if="scoreCost.show_price_per_mt">
      <showMaybeValue
        :value="inScoreCurrency((cost * scoreCost.change_rate) / netWeight)"
        :assertion="netWeight != 0"
        warningMessage="Net weight should not be null"
      />
    </td>

    <td class="clickable" v-if="scoreCost.show_net_weight">
      {{ netWeight }}
    </td>

    <td class="clickable" v-if="scoreCost.show_supplier_total_percentage">
      <showMaybeValue
        :value="((100 * cost) / buyingPrice).toFixed(2)"
        :assertion="buyingPrice != 0"
        warningMessage="Buying price should not be null"
      />
    </td>

    <td class="clickable" v-if="scoreCost.show_customer_total_percentage">
      <showMaybeValue
        :value="((100 * cost) / sellingPrice).toFixed(2)"
        :assertion="sellingPrice != 0"
        warningMessage="Selling price should not be null"
      />
    </td>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import scoreCost from "../../mixins/scoreCost";
import showMaybeValue from "../shared/showMaybeValue";

export default {
  mixins: [scoreCost],
  components: { showMaybeValue },
  props: {
    scoreCost: {
      type: Object,
      required: true,
    },
    previsional: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters("contractStore", [
      "contract",
      "totalBuyingPrice",
      "totalSellingPrice",
    ]),
    cost() {
      return this.getCost(this.scoreCost);
    },
    netWeight() {
      return this.totalNetWeight(this.scoreCost);
    },
    buyingPrice() {
      return this.totalBuyingPrice(this.previsional);
    },
    sellingPrice() {
      return this.totalSellingPrice(this.previsional);
    },
  },
};
</script>
